import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-del",
  "use": "icon-icon-del-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-del\"><path d=\"M853.333333 533.333333C865.115407 533.333333 874.666667 523.782075 874.666667 512 874.666667 500.217925 865.115407 490.666667 853.333333 490.666667L170.666667 490.666667C158.884592 490.666667 149.333333 500.217925 149.333333 512 149.333333 523.782075 158.884592 533.333333 170.666667 533.333333L853.333333 533.333333Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol